"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Aug 13 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var ProductNameAndCategoriesConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductNameAndCategoriesConverter, _DataObjectConverter_);

  function ProductNameAndCategoriesConverter() {
    _classCallCheck(this, ProductNameAndCategoriesConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductNameAndCategoriesConverter).apply(this, arguments));
  }

  return ProductNameAndCategoriesConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductNameAndCategoriesConverter = ProductNameAndCategoriesConverter;